<template>
  <v-card
    tile
    class="mtfont"
  >
    <div class="video-header">
      <video autoplay muted="muted" loop>
        <source src="https://cdn.shopify.com/s/files/1/2636/4748/files/MIXING.mp4?v=1617835438" type="video/mp4">
      </video>
    </div>

    <v-container class="pa-6" id="FormulaPrintArea">
      <v-row>
        <v-col cols="7" class="py-0">FN-INK PANTONE FORMULA:</v-col>
        <v-col cols="5" class="py-0">PANTONE {{currentColor.code}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="7" class="py-0">{{currentColor.grams}} GRAMS</v-col>
        <v-col cols="5" class="py-0"><small>{{ (new Date()).toLocaleDateString() }}</small></v-col>
      </v-row>

      <v-simple-table style="border: 1px solid lightgrey;" class="mt-2">
          <template >
            <thead>
              <tr>
                <th class="text-center">
                  COLOR
                </th>
                <th class="text-left">
                  NAME
                </th>
                <th class="text-right">
                  AMOUNT(g)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in materials"
                :key="item.name"
              >
                <td width="20px"> <LighteningBoltIndicater :hexColor="item.hex" /> </td>
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.amount }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
    </v-container>

    <v-card-actions>
      <v-select
              id="versionSelect"
              :items="versions"
              v-model="version"
              :item-text="versionToDate"
              item-value="createdAt"
              style="width: 35px; font-size: 14px;"
              item-color="accent"
              color="accent"
              class="mx-2 mt-4"
              outlined
              dense
              label="version"
              v-on:change="changeFormulaVersion"
      ></v-select>

      <v-spacer></v-spacer>
      <span v-if="$store.getters.loggedIn">
        <v-btn text v-if="!isFavorite" color="secondary" v-on:click="favoriteCurrentFormula">
          Save Formula
          <!--<v-icon v-if="!isFavorite" color="secondary">favorite_border</v-icon>
          <v-icon v-else color="secondary">favorite</v-icon> -->
        </v-btn>
        <v-btn text disabled v-else color="secondary">
          Saved
          <!--<v-icon v-if="!isFavorite" color="secondary">favorite_border</v-icon>
          <v-icon v-else color="secondary">favorite</v-icon> -->
        </v-btn>
      </span>
      <v-btn
        depressed
        color="black"
        style="color: #fecb39;"
        large
        class="mb-3 mr-3"
        v-on:click="printDiv"
      >PRINT FORMULA</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import LighteningBoltIndicater from '@/components/Admin/LighteningBoltSwatch.vue';

  export default {
    name: 'FormulaCard',

    components: {
      LighteningBoltIndicater
    },

    data: () => ({
      version: null
    }),
    computed: {
      isFavorite() {
        const userFavorites = this.$store.getters.getUserFavorites;
        const foundFavorite = userFavorites.find(favorite => {
          const sameColor = favorite.color.code === this.$store.getters.getCurrentColor.code;
          const sameVersion = this.version === favorite.version;
          return sameColor && sameVersion;
        });

        return !!foundFavorite;
      },
      versions() {
        if(!this.$store.getters.getCurrentColor.formula) return [];

        const history = this.$store.getters.getCurrentColor.formula.history;
        this.version = this.$store.getters.getCurrentColor.formula.createdAt;

        return [this.$store.getters.getCurrentColor.formula, ...history];
      },
      currentColor() {
        return this.$store.getters.getCurrentColor || {};
      },
      materials() {
        if(!(this.currentColor.formula && this.currentColor.formula.materials)) return [];
        const grams = +this.currentColor.grams;

        const formula = !this.version || this.version === this.currentColor.formula.createdAt?
                this.currentColor.formula:
                this.currentColor.formula.history.find(formula => formula.createdAt === this.version);

        return !formula? []: formula.materials.map( material => ({
            code: material.material.code,
            name: material.material.name,
            amount: ((+material.amount * +grams)/+this.currentColor.formula.multiplier).toFixed(2),
            hex: material.material.hex
          }));
      },
    },
    methods: {
      favoriteCurrentFormula: function() {
        const formula = !this.version || this.version === this.currentColor.formula.createdAt?
            this.currentColor.formula:
            this.currentColor.formula.history.find(formula => formula.createdAt === this.version);

        const formulaFavorite = {
          color: this.currentColor.id,
          formula: formula.id,
          version: this.version
        };

        console.log(JSON.stringify(formulaFavorite))

        this.$store.dispatch('addNewFormulaFavorite', formulaFavorite)
          .then(result => {
            this.$store.dispatch('getUserFavorites')
          })
          .catch(e => console.error(e));
      },
      changeFormulaVersion: function(event) {
        this.version = event;
      },
      versionToDate: function(value) {
        return new Date(+value.createdAt).toLocaleDateString();
      },
      printDiv: function() { 
        var divContents = document.getElementById("FormulaPrintArea").innerHTML;
        var a = window.open('', '', 'height=600, width=900'); 
        a.document.write(`<html><head>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@900">
          <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">
          </head><body style="padding: 10px;"><v-container style="font-family: 'Montserrat', sans-serif;">`);
        a.document.write(divContents);
        a.document.write(`<br><small style="color:grey;">Version: ${new Date(+this.version).toLocaleDateString()}</small>`);
        a.document.write('</v-container></body></html>');
        a.document.close();
        setTimeout(function(){ a.print(); a.close(); }, 600);
      }
    }
  }
</script>

<style scoped>
.video-header {
  width: 100%;
  overflow: hidden;
  display:block;
  height: 70px;
}
</style>
